import { Button, ExternalButton } from "../../components/Button";
import { useConfig } from "../../hooks/useConfig";
import { PAIR_FALLBACK } from "../../lib/facts";
import { Link } from "../../router/router";

export function Hero() {
  const { config, loading } = useConfig();
  const ponsUrl = config?.ponsUrl ?? null;
  const pair = config?.pair.symbol ?? PAIR_FALLBACK;

  return (
    <section className="shell hero">
      <div className="stack stack-5">
        <p className="eyebrow">Robinhood Chain, paired with {pair}</p>
        <h1 className="hero__title">
          $TISM<span className="accent">.</span>
        </h1>
        <p className="lede">
          $TISM is a memecoin for autism acceptance. It launches on Robinhood Chain through the
          Pons v2 launchpad, and it is bought and sold in {pair}.
        </p>
        <p className="lede">
          50% of the creator's share of trading fees is donated to a Vancouver autism charity.
        </p>
        <div className="hero__actions">
          {ponsUrl ? (
            <ExternalButton href={ponsUrl}>Buy on Pons</ExternalButton>
          ) : (
            <>
              <Button variant="ghost" disabled title="Not launched yet">
                {loading ? "Loading" : "Buy on Pons"}
              </Button>
              <span className="btn__note">Not launched yet.</span>
            </>
          )}
          {config?.links?.dexscreener ? (
            <ExternalButton href={config.links.dexscreener} variant="ghost">
              Chart
            </ExternalButton>
          ) : null}
          <Link to="/airdrop" className="btn btn--ghost">
            Check airdrop eligibility
          </Link>
        </div>
        {config?.launch?.graduated ? (
          <p className="tiny">
            Graduated{config.launch.graduatedAt ? ` on ${config.launch.graduatedAt}` : ""}: the curve raised its
            target and liquidity is locked in Uniswap v4.
          </p>
        ) : null}
      </div>
    </section>
  );
}
